import logo from './lseg-logo.svg';
import user from './images/user.svg';
import './App.css';
import { useEffect, useRef, useState } from 'react';
import { createTreeRenderer } from "@refinitiv-ui/elements/tree";
import MainContent from './components/MainContent';
import Auth from './methods/Auth';
import dataServices from "./services/DataServices";
import { syncVersions } from './components/admin/Helpers';

const appName = process.env.REACT_APP_TITLE;

function Header(props) {
  const [showMenu, setShowMenu] = useState(false);
  
  function logout() {
    Auth.logout();
    window.location.reload();
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      const menu = document.querySelector('.user-menu');
      const userSpan = document.querySelector('.usr-span');
      if (menu && !menu.contains(event.target) && !userSpan.contains(event.target)) {
        setShowMenu(false);
      }
    };
    
    if (showMenu) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [showMenu]);

  return (
    <header className="App-header">
      <ef-layout flex>
        <ef-layout className="left"><img src={logo} className="App-logo" alt="logo" /></ef-layout>
        {Auth.role === 'owner' && (
        <ef-layout className="right">
          <img src={Auth.currentUser.photo ? Auth.currentUser.photo : user} className="user-img" alt="user" />
          <span className='usr-span' onClick={() => setShowMenu(!showMenu)}>
            {Auth.currentUser ? Auth.currentUser.name[0]+" "+Auth.currentUser.name[1]: ''}<ef-icon icon="down"></ef-icon>
          </span>
          {showMenu && (
            <ef-card className="user-menu"onClick={() => setShowMenu(false)}>
              <ef-button transparent icon="profile" class="card-btn" onClick={() => props.setCurrentTab('0.2')}>Profile</ef-button><br />
              <ef-button transparent icon="excel" class="card-btn" onClick={() => props.setCurrentTab('0.1')}>Upload</ef-button><br />
              <ef-button transparent icon="msgr-adduser" class="card-btn" onClick={() => props.setCurrentTab('0.3')}>User Management</ef-button><br />
              <ef-button transparent icon="grc-log-out" class="card-btn" onClick={logout}>Logout</ef-button>
            </ef-card>
          )}
        </ef-layout>
        )}
        {Auth.role === 'admin' && (
        <ef-layout className="right">
          <img src={Auth.currentUser.photo ? Auth.currentUser.photo : user} className="user-img" alt="user" />
          <span className='usr-span' onClick={() => setShowMenu(!showMenu)}>
            {Auth.currentUser ? Auth.currentUser.name[0]+" "+Auth.currentUser.name[1]: ''}<ef-icon icon="down"></ef-icon>
          </span>
          {showMenu && (
            <ef-card className="user-menu"onClick={() => setShowMenu(false)}>
              <ef-button transparent icon="profile" class="card-btn" onClick={() => props.setCurrentTab('0.2')}>Profile</ef-button><br />
              <ef-button transparent icon="excel" class="card-btn" onClick={() => props.setCurrentTab('0.1')}>Upload</ef-button><br />
              <ef-button transparent icon="grc-log-out" class="card-btn" onClick={logout}>Logout</ef-button>
            </ef-card>
          )}
        </ef-layout>
        )}
        {Auth.role === 'user' && (
        <ef-layout className="right">
          <img src={Auth.currentUser.photo ? Auth.currentUser.photo : user} className="user-img" alt="user" />
          <span className='usr-span' onClick={() => setShowMenu(!showMenu)}>
            {Auth.currentUser ? Auth.currentUser.name[0]+" "+Auth.currentUser.name[1]: ''}<ef-icon icon="down"></ef-icon>
          </span>
          {showMenu && (
            <ef-card className="user-menu"onClick={() => setShowMenu(false)}>
              <ef-button transparent icon="individual" class="card-btn" onClick={() => props.setCurrentTab('0.2')}>Profile</ef-button><br />
              <ef-button transparent icon="grc-log-out" class="card-btn" onClick={logout}>Logout</ef-button>
            </ef-card>
          )}
        </ef-layout>
        )}
        {Auth.role === 'new' && (
        <ef-layout className="right">
          <img src={Auth.currentUser.photo ? Auth.currentUser.photo : user} className="user-img" alt="user" />
          <span className='usr-span' onClick={() => setShowMenu(!showMenu)}>
            {Auth.currentUser ? Auth.currentUser.name[0]+" "+Auth.currentUser.name[1]: 'User'}<ef-icon icon="down"></ef-icon>
          </span>
          {showMenu && (
            <ef-card className="user-menu"onClick={() => setShowMenu(false)}>
              <ef-button transparent icon="grc-log-out" class="card-btn" onClick={logout}>Logout</ef-button>
            </ef-card>
          )}
        </ef-layout>
        )}
      </ef-layout>
    </header>
  );
}

function Sidebar(props) {
  let { currentTab, setCurrentTab } = props;
  let selected = useRef('1.1');

  useEffect(() => {
    const tree = document.getElementById('sidebarTree');
    const defaultRenderer = createTreeRenderer(tree);
    tree.renderer = (item, composer, element) => {
      element = defaultRenderer(item, composer, element);
      let span = element.querySelector("span");
      if (!span) {
        span = document.createElement("span");
        span.textContent = composer.getItemPropertyValue(item, "label");
        element.appendChild(span);
      }
      return element;
    };

    tree.addEventListener('value-changed', (event) => {
      const newValue = event.detail.value;
      setCurrentTab(newValue);
      selected.current = newValue;
      tree.collapseAll();
      const treeNodes = tree.manager.getTreeNodes();
      const node = treeNodes.find(treeNode => treeNode.value === newValue.split('.')[0]);
      if (node) {
        node.expanded = true;
      }
    });

    const layout = document.querySelector('ef-sidebar-layout');
    const toggleButton = document.getElementById('toggleButton');
    toggleButton.addEventListener('click', () => {
      layout.collapsed = !layout.collapsed;
      toggleButton.setAttribute('icon', layout.collapsed ? 'leftpanel-closed' : 'leftpanel-open');
    });
    const data = [
      {
        label: 'Company Snapshot',
        expanded: true,
        icon: 'Industry',
        value: '1',
        items: [
          { label: 'Entity Reference', value: '1.1', selected: true },
          { label: 'Financial Statements', value: '1.2', selected: false },
          { label: 'Operating Metrix KPIs', value: '1.3', selected: false },
          { label: 'Segments', value: '1.4', selected: false },
          { label: 'Industry Medians', value: '1.5', selected: false },
          { label: 'Current Analytics', value: '1.6', selected: false },
          { label: 'Price Volume Analytics', value: '1.7', selected: false },
          { label: 'All Estimates', value: '1.8', selected: false },
          { label: 'Latest & Historical Analytics', value: '1.9', selected: false }
        ]
      },
      {
        label: 'Events',
        icon: 'calendar',
        value: '2',
        items: [
          { label: 'Corporate Actions', value: '2.1', selected: false },
          { label: 'Earnings & Corporate', value: '2.2', selected: false },
          { label: 'Economic', value: '2.3', selected: false },
          { label: 'Holidays', value: '2.4', selected: false },
          { label: 'IPO', value: '2.5', selected: false },
          { label: 'Mergers & Acquisitions', value: '2.6', selected: false }
        ]
      },
      {
        label: 'ESG',
        icon: 'corporate-actions',
        value: '3',
        items: [
          { label: 'ESG Scores', value: '3.1', selected: false },
          { label: 'Diversity & Inclusion Scores', value: '3.2', selected: false },
          { label: 'Environmental Measures', value: '3.3', selected: false },
          { label: 'Social Measures', value: '3.4', selected: false },
          { label: 'Governance Measures', value: '3.5', selected: false }
        ]
      },
      {
        label: 'Filings',
        icon: 'corporate-actions',
        value: '4',
        items: [
          { label: 'Edgar', value: '4.1', selected: false },
          { label: 'Cris', value: '4.2', selected: false },
          { label: 'Sedar', value: '4.3', selected: false },
          { label: 'Tanshin', value: '4.4', selected: false },
          { label: 'Yuho', value: '4.5', selected: false },
          { label: 'OBI', value: '4.6', selected: false },
          { label: 'China', value: '4.7', selected: false },
          { label: 'Dart', value: '4.8', selected: false },
          { label: 'Bridge', value: '4.9', selected: false },
          { label: 'SEC NonEdgar', value: '4.10', selected: false },
          { label: 'Italy', value: '4.11', selected: false },
          { label: 'Muni', value: '4.12', selected: false }
        ]
      },
      {
        label: 'IBES Estimates',
        icon: 'calc',
        value: '5',
        items: [
          { label: 'Measures', value: '5.1', selected: false },
          { label: 'Fields', value: '5.2', selected: false }
        ]
      },
      {
        label: 'Lipper(Funds)',
        icon: 'dividend',
        value: '6',
        items: [
          { label: 'Fees & Expenses Data', value: '6.1', selected: false },
          { label: 'Holdings', value: '6.2', selected: false },
          { label: 'Price & Performance Data', value: '6.3', selected: false },
          { label: 'Reference Data', value: '6.4', selected: false },
          { label: 'Time Series', value: '6.5', selected: false }
        ]
      },
      {
        label: 'News',
        icon: 'news',
        value: '7',
        items: [
          { label: 'Packages', value: '7.1', selected: false }
        ]
      },
      {
        label: 'Ownership',
        icon: 'admin-profile',
        value: '8',
        items: [
          { label: 'Packages', value: '8.1', selected: false },
          { label: 'Fields', value: '8.2', selected: false },
          { label: 'Stocks', value: '8.3', selected: false },
          { label: 'Funds', value: '8.4', selected: false }
        ]
      },
      {
        label: 'Streaming & Snapshot Quotes',
        icon: 'image',
        value: '9',
        items: [
          { label: 'Exchange Traded Instrument (ETI)', value: '9.1', selected: false },
          { label: 'Refinitiv Indices', value: '9.2', selected: false },
          { label: 'Economic Indicators', value: '9.3', selected: false },
          { label: 'Fixed Income', value: '9.4', selected: false },
          { label: 'FX Real-time', value: '9.5', selected: false }
        ]
      }
    ];
    tree.data = data;
  }, [setCurrentTab]);
  

  return (
    <ef-sidebar-layout className="app-sidebar-layout" sidebarWidth="280px">
      <ef-header slot="sidebar-header" level="1">Services</ef-header>
      <ef-panel spacing slot="sidebar-content" className="sidebar-panel">
        <ef-tree id="sidebarTree" className="sidebar-tree"></ef-tree>
      </ef-panel>
      <ef-header slot="main-header" level="1">
        <ef-button transparent slot="left" id="toggleButton" icon="leftpanel-open"></ef-button>
      </ef-header>
      <ef-panel spacing slot="main-content" className="main-content-panel">
        { currentTab.startsWith('0.') && <ef-button transparent className="back-button" icon="back" onClick={() => setCurrentTab(selected.current)}>Back</ef-button> }
        <MainContent activeTab={currentTab} />
      </ef-panel>
    </ef-sidebar-layout>
  );
}

function RequestAccess() {

  function requestAccess() {
    const user = Auth.currentUser
    const body = {
      "uid": String(user.id),
      "role_ids": ["69018"],
      "cmt": "the reason"
    }
    let resp = dataServices.sendiRPMRequest('apply-role', body)
    resp.then((res) => {
      console.log(res)
      if(res.status === "OK"){
        alert("Access request submitted successfully. Our team will review your request and get back to you shortly.")
      }else{
        alert("Failed to submit access request. Please try again later.")
      }
    }).catch((err) => {
      console.error("Error requesting access:", err);
      alert("An error occurred while submitting your access request. Please try again later.")
    });
  }

  return (
    <div className="request-access">
      <p>You do not have access to this application. Please click the below button to request access.</p>
      <p>*If you are seeing same screen even after getting the access, please logout and login again by clicking on the right top corner.</p>
      <ef-button label="Request Access" onClick={requestAccess}>Request Access</ef-button>
    </div>
  );
}

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [currentTab, setCurrentTab] = useState('1.1');
  useEffect(() => {
    localStorage.setItem('appId', appName)
    setTimeout(() => {
      Auth.checkLogin()
      setLoggedIn(Auth.loggedIn)
      if(Auth.loggedIn) {
        syncVersions();
      }
    }, 100)
  }, [loggedIn]);

  return (
    <div className="App">
      {loggedIn &&
        <Header setCurrentTab={setCurrentTab} />
      }
      {loggedIn && Auth.role !== 'new' &&
        <Sidebar currentTab={currentTab} setCurrentTab={setCurrentTab} />
      }
      {loggedIn && Auth.role === 'new' &&
        <RequestAccess />
      }
    </div>
  );
}

export default App;
